export function StripeWordmark({ className }: { className?: string }) {
  return (
    <span className={['stripe-wordmark', className].filter(Boolean).join(' ')}>
      Stripe
      <sup className="tm">™</sup>
    </span>
  );
}
